export default __webpack_public_path__ + "static/media/disabled-hyperlink-icon.c53eec4e.svg";